// src/components/Labs/biology/apparatus/SlideView.jsx
import React from "react";
import { useDrop } from "react-dnd";
import { motion } from "framer-motion";
import { ItemTypes } from "../../../../utils/constants";

export default function SlideView({ loaded, specimenName, image, onSpecimenDrop }) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.SPECIMEN,
      drop: (item) => {
        if (onSpecimenDrop) onSpecimenDrop(item);
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    }),
    [onSpecimenDrop]
  );

  const src = loaded && image ? `/biology-slides/${image}` : null;

  return (
    <div className="flex flex-col items-center">
      <div
        ref={drop}
        className={[
          "relative w-72 h-40 bg-white border shadow rounded-xl flex items-center justify-center overflow-hidden",
          "transition-all duration-200",
          isOver ? "ring-4 ring-pink-400 scale-105" : "",
        ].join(" ")}
      >
        {!loaded || !src ? (
          <p className="text-xs text-gray-500 text-center px-2">
            Drop slide to view
          </p>
        ) : (
          <motion.img
            src={src}
            alt={specimenName}
            className="object-cover w-40 h-40 rounded-full"
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
          />
        )}
      </div>

      <p className="text-xs mt-2 text-gray-700">
        {loaded ? specimenName : "Slide Viewer"}
      </p>
    </div>
  );
}
